import { businessHourIndex } from '@/utils/reportCompare';
import { TableOccupancyDuration } from '@/types/TableReport.interface';

/**
 * Peak-hour buckets in business-day order (07:00 first), trimmed to the span
 * that had any check so a quiet night does not fill the chart with zeros.
 */
export function peakHoursInBusinessOrder(
  hours: { hour: number; checkCount: number }[]
): { hour: number; checkCount: number }[] {
  const ordered = [...hours].sort(
    (a, b) => businessHourIndex(a.hour) - businessHourIndex(b.hour)
  );
  const first = ordered.findIndex((bucket) => bucket.checkCount > 0);
  if (first === -1) return [];
  let last = ordered.length - 1;
  while (last > first && ordered[last].checkCount === 0) last -= 1;
  return ordered.slice(first, last + 1);
}

/** Occupancy buckets in display order with their label keys. */
export const OCCUPANCY_BUCKETS: {
  key: keyof TableOccupancyDuration['distribution'];
  labelKey: string;
}[] = [
  { key: 'short', labelKey: 'tableReports.occupancy.short' },
  { key: 'medium', labelKey: 'tableReports.occupancy.medium' },
  { key: 'long', labelKey: 'tableReports.occupancy.long' },
  { key: 'veryLong', labelKey: 'tableReports.occupancy.veryLong' },
  { key: 'extended', labelKey: 'tableReports.occupancy.extended' }
];

/** "1 sa 25 dk" / "45 dk". */
export const formatMinutes = (minutes: number): string => {
  const total = Math.max(0, Math.round(minutes || 0));
  const hours = Math.floor(total / 60);
  const rest = total % 60;
  if (hours === 0) return `${rest} dk`;
  return rest === 0 ? `${hours} sa` : `${hours} sa ${rest} dk`;
};
